import { createEventService } from "../infrastructure/services/createEventService";
import { CreateEventRequest, EventActions } from "../domain/events";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const createEvent = {
  async execute(
    name: string,
    lastDate: string,
    maxInvites: number
  ): Promise<void> {
    const request: CreateEventRequest = await EventActions().createEventRequest(
      name,
      lastDate,
      maxInvites
    );
    await createEventService.execute(await tokenValidation.execute(), request);
  },
};
